import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Divider,
  Tooltip,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';

import styles from './styles';
import { SLACK_DELIVERY_METHOD } from '../EventTypesCard';

const isURL = (str) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
  + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' // domain name
  + '((\\d{1,3}\\.){3}\\d{1,3}))' // ip (v4) address
  + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port
  + '(\\?[;&amp;a-z\\d%_.~+=-]*)?' // query string
  + '(\\#[-a-z\\d_]*)?$', 'i');
  return pattern.test(str) && str.indexOf('https://hooks.slack.com/services/') === 0;
};

export class SlackNotificationsModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSlackSubscription: false,
      hasChanged: false,
      isValid: true,
      slackSubsciption: {
        type: SLACK_DELIVERY_METHOD,
        webhookUrl: '',
        optOuts: [],
        deviceId: null,
        deviceName: null,
        deviceToken: null,
        provider: null,
      },
    };
  }

  componentDidUpdate(prevProps) {
    const slackNotifications = this.props.userSubscription.subscriptions

      ? this.props.userSubscription.subscriptions.filter((subscription) => subscription.type === SLACK_DELIVERY_METHOD)
      : [];

    const prevSlackNotification = prevProps.userSubscription.subscriptions

      ? prevProps.userSubscription.subscriptions.filter((subscription) => subscription.type === SLACK_DELIVERY_METHOD)
      : [];

    if (JSON.stringify(slackNotifications) !== JSON.stringify(prevSlackNotification)) {
      this.resetState(slackNotifications);
    }
  }

  resetState = (slackNotifications) => {
    this.setState({
      hasSlackSubscription: slackNotifications.length > 0,
      hasChanged: false,
      isValid: true,
      slackSubsciption: {
        type: SLACK_DELIVERY_METHOD,
        webhookUrl: slackNotifications.length > 0
          ? slackNotifications[0].webhookUrl
          : '',
        optOuts: [],
        deviceId: null,
        deviceName: null,
        deviceToken: null,
        provider: null,
      },
    });
  }

  closeModal = () => {
    this.props.closeSlackNotificationsModal();
  }

  handleChangeWebhookUrl = (e) => {
    const changedValue = e.target.value;
    const isValid = isURL(changedValue);

    this.setState((prevState) => ({
      isValid,
      hasChanged: true,
      slackSubsciption: {
        ...prevState.slackSubsciption,
        webhookUrl: changedValue,
      },
    }));
  }

  removeSlackSubscription = () => {
    const newSubscriptions = this.props.userSubscription.subscriptions

      ? this.props.userSubscription.subscriptions.filter((subscription) => subscription.type !== SLACK_DELIVERY_METHOD)
      : [];

    this.props.userSubscription.subscriptions = newSubscriptions;
    this.props.updateUserSubscription(this.props.userId, this.props.userSubscription);
    this.closeModal();
  }

  saveSlackSubcription = () => {
    if (isURL(this.state.slackSubsciption.webhookUrl)) {
      const newSubscriptions = this.props.userSubscription.subscriptions
        ? this.props.userSubscription.subscriptions
          .filter((subscription) => subscription.type !== SLACK_DELIVERY_METHOD)
        : [];
      newSubscriptions.push(this.state.slackSubsciption);

      this.props.userSubscription.subscriptions = newSubscriptions;
      this.props.updateUserSubscription(this.props.userId, this.props.userSubscription);
      this.closeModal();
    } else {
      this.setState({ isValid: false });
    }
  }

  render() {
    const { classes } = this.props;
    const {
      hasSlackSubscription,
      hasChanged,
      isValid,
      slackSubsciption,
    } = this.state;

    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={this.closeModal}
          fullScreen={this.props.fullScreen}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Slack Notifications</DialogTitle>
          <DialogContent className={classes.container}>
            <DialogContentText>
              Get notified of Pingum events through Slack.
              Provide your slack Incoming Webhook URL below.
            </DialogContentText>

            <FormControl className={classes.formControl} variant="outlined" fullWidth error={!isValid}>
              <InputLabel
                htmlFor="component-outlined"
              >
                Incoming Webhook URL
              </InputLabel>
              <OutlinedInput
                labelWidth={170}
                id="component-outlined"
                value={slackSubsciption.webhookUrl}
                onChange={this.handleChangeWebhookUrl}
              />
              {
                !isValid
                && <FormHelperText id="component-error-text">Please provide a valid Webhook URL that starts with <b>https://hooks.slack.com/services/...</b></FormHelperText>
              }
            </FormControl>

            <Typography variant="caption">
              After creating your slack app, enabled Incoming Webhooks,
              and generating the URL to post notifications to your slack channel,
              copy the URL and paste it above.
            </Typography>

            <Divider className={classes.contentDivider} />

            <div className={classes.helpContainer}>
              <Typography variant="h4">
                Need help setting up your slack notifications?
              </Typography>
              <Typography>
                Follow the below instructions,
                or checkout
                <a href="https://api.slack.com/incoming-webhooks" target="blank"> this article </a>
                (only steps 1-3) to create your Incoming Webhook URL
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemIcon>
                    <Icon>fiber_manual_record</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={<span>Create a <a href="https://api.slack.com/apps?new_app=1" target="blank"> Slack app</a></span>}
                    secondary="If you don't already have one"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Icon>fiber_manual_record</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={<span>Enable <b>Incoming Webhooks</b> from the settings page.</span>}
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Icon>fiber_manual_record</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={(
                      <span>
                        After the settings page refreshes, click
                        <b> Add New Webhook to Workspace.</b>
                      </span>
                    )}
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Icon>fiber_manual_record</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary="Pick a channel that Pingum will post to, then click Authorize."
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Icon>fiber_manual_record</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={<span>Copy your <a href="https://api.slack.com/incoming-webhooks#posting_with_webhooks" target="blank">Incoming Webhook URL</a> and paste it above to enable slack Notifications from Pingum</span>}
                  />
                </ListItem>
              </List>
            </div>

          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeModal}
            >
              Cancel
            </Button>
            {
              hasSlackSubscription
              && (
                <Tooltip title="Remove Slack Notifications">
                  <Button
                    color="secondary"
                    onClick={this.removeSlackSubscription}
                  >
                    Remove
                  </Button>
                </Tooltip>
              )
            }
            <Button
              variant="contained"
              onClick={this.saveSlackSubcription}
              color="primary"
              disabled={!hasChanged || !isValid}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SlackNotificationsModalComponent.propTypes = {
  classes: PropTypes.object,
  isOpen: PropTypes.bool,
  closeSlackNotificationsModal: PropTypes.func,
  fullScreen: PropTypes.bool,
  updateUserSubscription: PropTypes.func,
  userId: PropTypes.string,
  userSubscription: PropTypes.object,
};

SlackNotificationsModalComponent.defaultProps = {
  classes: {},
  isOpen: false,
  closeSlackNotificationsModal: () => {},
  fullScreen: false,
  updateUserSubscription: () => {},
  userId: '',
  userSubscription: {},
};

export default (withMobileDialog({ breakpoint: 'xs' })(withStyles(styles)(SlackNotificationsModalComponent)));
